"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabelaRodape = void 0;
var react_1 = __importDefault(require("react"));
var styles = require('./TabelaRodape.module.scss');
var Botao_1 = require("../../Botao/Botao");
var Cores_1 = require("../../Cores/Cores");
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var Flex_1 = require("../Flex");
var Icone_1 = require("../../Icone/Icone");
var Paginacao_1 = require("../../Paginacao/Paginacao");
var TabelaRodape = function (_a) {
    var itensPorPagina = _a.itensPorPagina, totalItens = _a.totalItens, paginaAtual = _a.paginaAtual, onChangePagina = _a.onChangePagina, onChangeItensPorPagina = _a.onChangeItensPorPagina, showBotaoExportar = _a.showBotaoExportar, onClickExportar = _a.onClickExportar;
    return (react_1.default.createElement("div", { className: styles.footerTable },
        showBotaoExportar && (react_1.default.createElement(Botao_1.Botao, { tipoComportamento: "button", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU100, tipo: "tipoDefault", style: { minWidth: "100px", marginRight: "10px" }, onClick: onClickExportar },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "button1", cor: Cores_1.Cores.CoresIdentidadeMU.azulMu, negrito: 700 },
                react_1.default.createElement(Flex_1.FlexRow, { gap: "1rem" },
                    "Exportar",
                    react_1.default.createElement(Icone_1.Icone, { nome: "download", cor: Cores_1.Cores.CoresIdentidadeMU.azulMu, altura: "18px", largura: "18px" }))))),
        react_1.default.createElement(Paginacao_1.Paginacao, { itensPorPagina: itensPorPagina, totalItens: totalItens, paginaAtual: paginaAtual, onPageChange: onChangePagina, onItensPorPaginaChange: onChangeItensPorPagina })));
};
exports.TabelaRodape = TabelaRodape;
